import { ActionDataGrid6 } from "../../form/ActionDataGrid6";

export const columnDefStep6 = (bloqueado: boolean = false): any => {
    return [
        { field: 'contrato', headerName: 'Contrato', minWidth: 120 },
        { field: 'id', hide: true },
        { field: 'fatherStructure4', headerName: 'Grupo estructura', minWidth: 200, rowDrag: true },
        { field: 'structure', headerName: 'Estructura', minWidth: 200 },
        { field: 'idRecipe', headerName: 'Id Receta', minWidth: 100 },
        { field: 'recipe', headerName: 'Receta', minWidth: 180 },
        {
            field: 'Acción',
            minWidth: 150,
            cellRenderer: (params: any) => {
                if (!bloqueado)
                    return <ActionDataGrid6 dataRow={params.node.data} />
                else
                    return <></>
            },
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: true,
        },
    ]
}